import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventListComponent } from './event-list/event-list.component';
import { MrsiComponent } from './mrsi.component';
import { OverallFeedbackComponent } from './overall-feedback/overall-feedback.component';


const routes: Routes = [{
  path:'',
  component:MrsiComponent,
  children:[
    {path:'',component:EventListComponent},
    {path:'event-list',component:EventListComponent},
    {path:'event-list/:id',component:EventListComponent},
    {path:'overall-feedback',component:OverallFeedbackComponent},
  ]
}]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MrsiRoutingModule { }
